var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","max-width":"200px"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"ma-auto",attrs:{"icon":""},on:{"click":_vm.snapShot}},on),[_c('v-icon',[_vm._v(" mdi-content-save ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('screenshot'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }